export default "__VITE_ASSET__D$lADZPU__"